exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".Members__membersRow___2lk4H {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  max-width: 900px;\n  margin: 0 auto;\n}\n@media (min-width: 1500px) {\n  .Members__membersRow___2lk4H {\n    max-width: 1200px;\n  }\n}\n@media (max-width: 767px) {\n  .Members__membersRow___2lk4H.Members__email___hnkvM,\n  .Members__membersRow___2lk4H.Members__call___1Rxdx {\n    display: none;\n  }\n}\n.Members__personButtonWrapper___1pIDr {\n  min-height: 40vh;\n  justify-content: space-around;\n}\n.Members__membersRow___2lk4H h3 {\n  margin-bottom: 12px;\n}\n.Members__membersRow___2lk4H p {\n  margin-top: 5px;\n  margin-bottom: 50px;\n  font-size: 0.8em;\n  line-height: 0.8em;\n}\n", ""]);

// exports
exports.locals = {
	"membersRow": "Members__membersRow___2lk4H",
	"email": "Members__email___hnkvM",
	"call": "Members__call___1Rxdx",
	"personButtonWrapper": "Members__personButtonWrapper___1pIDr"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./~/stylus-loader!./src/components/members/Members.styl
// module id = 231
// module chunks = 0